import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import faqModel from "models/faq.model";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import Swal from "sweetalert2";

const EditFaqs = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const [dataList, setDataList] = useState(null);
  const navigate = useNavigate();
  const parmas = useParams();

  const handleSubmitEditFAQ = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("id", parmas.id);
    // You can adjust the header configuration according to your API requirements
    faqModel
      .editFaqs(form)
      .then((response) => {
        helper.sweetalert.toast("Your Faqs Edit.", "success");
        navigate("/admin/fAQs");
        setAddsLoadig(false);
        // Display success message to the user
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const getListDataByid = () => {
    const data = {
      id: parmas?.id,
    };
    // Assuming '19' is the ID you want to send
    faqModel
      .listbyfaqsid(data)
      .then((response) => {
        setDataList(response.data.data);
        // console.log(response.data.data, "data");
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  // console.log(parmas?.id, "params");
  useEffect(() => {
    if (parmas.id != "") {
      getListDataByid();
    }
  }, []);

  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Edit Faqs</h3>
              </CardHeader>
              <CardBody>
                <div>
                  <Form onSubmit={handleSubmitEditFAQ}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Question</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="question"
                            placeholder="Enter Question"
                            defaultValue={dataList?.question}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Priority</Label>
                          <Input
                            id="Priority"
                            name="priority"
                            type="number"
                            defaultValue={dataList?.priority}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Answer</Label>
                          <Input
                            id="type"
                            name="answer"
                            type="textarea"
                            placeholder="Enter Answer"
                            defaultValue={dataList?.answer}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Type</Label>
                          <Input
                            id="forType"
                            name="forType"
                            type="select"
                            defaultValue={dataList?.type}
                          >
                            <option value="">select option</option>
                            <option value="Tutor">Tutor</option>
                            <option value="Student">Student</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button color="secondary" to="/admin/fAQs" tag={Link}>
                        Cancel
                      </Button>

                      <Button
                        color="primary"
                        type="submit"
                        style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white",border:"none"}}
                        // onClick={getListDataByid}
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default EditFaqs;
